import { useEffect, useState } from "react";
import axios from 'axios';
import Paginator from "../../components/Paginator"; 
import Wrapper from "../../components/Wrapper";
import { FcSearch , FcDownload} from "react-icons/fc";
 
const DailyUsers = ()=>{
    const today = new Date().toLocaleDateString('en-CA');
    const [appUsers, setAppUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [fileName,setFileName] = useState("");
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [searchDate, setSearchDate] = useState(today)
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`dailyUsers?page=${page}&date=${searchDate}`);
            setAppUsers(data.data);
            setLastPage(data.meta.last_page);
            setTotal(data.meta.total);

        }
        )();
    },[page]);
    // const del = async (id) =>{
    //     if(window.confirm("Are you sure you want to delete this record?")){
    //         await axios.delete(`appUsers/${id}`);
    //         setAppUsers(appUsers.filter((appUser) => appUser.id !== id));
    //     }
    // }

    const doSearch  = async (e)=>{
        
        const {data} = await axios.get(`dailyUsers?page=${page}&date=${searchDate}`);
        setAppUsers(data.data);
        setLastPage(data.meta.last_page);
       setTotal(data.meta.total);
    }

    const doDownload = async () => {
        const now = new Date();
        const epochTime = now.getTime(); 
        const epochTimeInSeconds = Math.floor(epochTime / 1000);
        setFileName("appUsers" + epochTimeInSeconds);
        try {
            const { data } = await axios.post('appUserDownload', {
                name:fileName,
                date:searchDate,
            }, { responseType: 'blob' });
            const blob = new Blob([data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    return (
        <Wrapper pageTitle={'Daily Customers'}>
            <div className="w-full overflow-x-auto bg-white text-right leading-10 text-purple-700 pr-2">  Page <span className="rounded-full bg-purple-700 text-white p-2">{page}</span>/{lastPage} Total Records: {total} </div>
            
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                    <div className="flex items-center">
    <label className="block text-sm mr-2">
       
        <input 
            type="date" 
            value={searchDate}
            className="block w-48 p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
            placeholder="Msisdn"
            onChange={e => setSearchDate(e.target.value)} 
        />
    </label>
    <button className="mr-2" onClick={doSearch}> <FcSearch title="Search by Date"/> </button>
    <button onClick={doDownload}><FcDownload title="Download"/>  </button>
</div>

                            <Paginator lastPage={lastPage} pageChanged={setPage} />
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Msisdn </th>
                                    <th className="px-4 py-3">MinBal </th>
                                    <th className="px-4 py-3">Bal </th>
                                    <th className="px-4 py-3">CreatedAt </th>
                                    <th className="px-4 py-3">UpdatedAt </th>
                                     
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {appUsers.map((appUser)=>{
                                         return(
                                             <tr key={appUser.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{appUser.id}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.MinBal}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.bal}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.created_at}</td>
                                                 <td className="px-4 py-3 text-sm">{appUser.updated_at}</td>
                                                 
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default DailyUsers;